/*
 * @Author: syyoon@yongtrim.com
 * @Date: 2018-07-09 17:33:50
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2019-01-22 00:16:40
 */

import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { PlatformService } from "./platform.service";
import { ToastController } from "ionic-angular";

@Injectable()
export class AlarmService {
  private _page: BehaviorSubject<any> = new BehaviorSubject(null);

  private curId: number = 0;
  private ids: any = {};

  constructor(
    private toastCtrl: ToastController,
    private platformService: PlatformService
  ) {}

  get page$() {
    return this._page.asObservable();
  }

  setPage(data: any) {
    this._page.next(data);
  }

  setupOn() {
    if (this.platformService.isWeb()) return;
    (<any>window).cordova.plugins.notification.local.on("click", obj => {
      this._page.next(obj.data);
    });
  }

  show(data: any) {
    if (!data.title && !data.message) return;
    if (!this.ids[data.id]) this.ids[data.id] = [];
    this.ids[data.id].push(this.curId);

    if (this.platformService.isWeb()) {
      const toast = this.toastCtrl.create({
        message: `${data.message}`,
        duration: 3000,
        position: "middle"
        // showCloseButton: false,
        // closeButtonText: '닫기',
        // cssClass: 'toast',
      });

      // toast.onDidDismiss(() => {
      //   this._page.next(data);
      // });

      toast.present();
    } else {
      (<any>window).cordova.plugins.notification.local.schedule({
        id: this.curId++,
        title: data.title || "",
        text: data.message || "",
        data: data,
        // sound: 'res://obey.mp3',
        smallIcon: "res://notify"
      });
    }
  }

  cancel(id: string) {
    if (this.ids[id])
      (<any>window).cordova.plugins.notification.local.cancel(this.ids[id]);
    this.ids[id] = null;
  }
}



// WEBPACK FOOTER //
// ./src/services/alarm.service.ts